import { render, staticRenderFns } from "./CheckpointLevelBanner.vue?vue&type=template&id=458ef23c&scoped=true"
import script from "./CheckpointLevelBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckpointLevelBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CheckpointLevelBanner.vue?vue&type=style&index=0&id=458ef23c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458ef23c",
  null
  
)

export default component.exports